import React from 'react';
import Timer from './Timer'; // Assuming Timer.js is in the same components folder

const Header = ({
  title,
  showBackButton,
  onBackClick,
  showTimerArea,
  timerKey,
  timerCurrentDuration,
  isTimerPaused,
  onTimerPause,
  onTimerResume,
  onTimerTick,
  onTimerComplete,
  onSkipTime,
}) => {

  return (
    <header style={styles.appHeader}>
      <div style={styles.titleBar}>
        {showBackButton && (
          <button onClick={onBackClick} style={styles.backButton}>
            &larr; Back
          </button>
        )}
        <h1 style={styles.title}>{title}</h1>
      </div>
      {showTimerArea && (
        <div style={styles.timerAreaContainer}>
          <div style={styles.timerDisplaySection}>
            <span style={styles.timerBarLabel}>Total Time:</span>
            <Timer
              key={timerKey}
              duration={timerCurrentDuration}
              onTick={onTimerTick}
              onComplete={onTimerComplete}
              onPause={onTimerPause}
              onResume={onTimerResume}
              isPaused={isTimerPaused}
              compact={true}
            />
          </div>
          <div style={styles.skipControlsContainer}>
            <button style={styles.skipButton} onClick={() => onSkipTime(-60)}>-1m</button>
            <button style={styles.skipButton} onClick={() => onSkipTime(-20)}>-20s</button>
            <button style={styles.skipButton} onClick={() => onSkipTime(20)}>+20s</button>
            <button style={styles.skipButton} onClick={() => onSkipTime(60)}>+1m</button>
          </div>
        </div>
      )}
    </header>
  );
};

const styles = {
  appHeader: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    zIndex: 1000,
    backgroundColor: '#f8f8f8',
    boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
  },
  titleBar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '10px 20px',
    borderBottom: '1px solid #eee',
    height: '35px', // Approx 55px total with padding/border
    position: 'relative', // For absolute positioning of back button
  },
  title: {
    margin: 0,
    fontSize: '1.5em',
    color: '#333',
    lineHeight: '1',
  },
  backButton: {
    position: 'absolute',
    left: '15px',
    top: '7px', // Fine-tuned for '35px' height of titleBar and 10px padding
    background: 'none',
    border: '1px solid #ccc',
    padding: '4px 8px', // Slightly smaller for header
    cursor: 'pointer',
    borderRadius: '5px',
    fontSize: '0.85em',
  },
  timerAreaContainer: { // New container for timer display and skip controls
    padding: '8px 15px',
    backgroundColor: 'rgba(230, 240, 255, 0.95)', 
    borderBottom: '1px solid #d4e8ff',
    // Total height for this area should be around 80px (135px total - 55px title bar)
  },
  timerDisplaySection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: '8px', // Space between timer and skip buttons
  },
  timerBarLabel: {
    fontSize: '0.95em',
    fontWeight: 'bold',
    color: '#007bff',
    marginRight: '10px',
  },
  skipControlsContainer: {
    display: 'flex',
    justifyContent: 'space-around', // Distribute buttons evenly
    alignItems: 'center',
  },
  skipButton: {
    background: '#007bff',
    color: 'white',
    border: 'none',
    padding: '6px 10px',
    fontSize: '0.8em',
    borderRadius: '4px',
    cursor: 'pointer',
    margin: '0 3px', // Small margin between buttons
    minWidth: '45px', // Ensure buttons have some width
  },
};

export default Header; 